export default "__VITE_ASSET__DIi7aarf__"